export const FREQUENCY = {
  WEEK_ID: 1,
  BIWEEK_ID: 2,
  MONTH_ID: 3,
  DAY_ID: 4,
  MINUTE_ID: 5,
  HOUR_ID: 6
};

export const FREQUENCY_DAYS = {
  WEEK: 7,
  BI_WEEK: 15,
  MONTH: 30
};
